import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { colors } from '../../../../../../colorVars';

function HorizontalTicks({ size, bottomPadding, scaleX, numberOfTicks, tickSize, weight }) {
  const ticks = useMemo(() => {
    if (scaleX !== null) {
      return scaleX.ticks(numberOfTicks).map((value) => ({
        value,
        offset: scaleX(value),
      }));
    }
  }, [scaleX, size, numberOfTicks]);
  return (
    <g stroke={colors.white} strokeWidth={weight}>
      <line x1={0} x2={size} y1={size + bottomPadding} y2={size + bottomPadding} />
      {ticks &&
        ticks.map(({ value, offset }) => (
          <line
            x1={offset}
            y1={size + bottomPadding}
            x2={offset}
            y2={size + bottomPadding - tickSize}
            key={value}
          />
        ))}
    </g>
  );
}

HorizontalTicks.propTypes = {
  numberOfTicks: PropTypes.number,
  scaleX: PropTypes.func,
  size: PropTypes.number,
  tickSize: PropTypes.number,
  weight: PropTypes.number,
  bottomPadding: PropTypes.number,
};

export default HorizontalTicks;
